import { Injectable } from '@angular/core';

const BIZ_OBJECT_CONFIG = [
  {
    id: 'user-login',
    name: '用户-登录账号',
    component: 'UserBrowseComponent',
    dataKey: 'login'
  },
  {
    id: 'tax-taxCode',
    name: '税率-金税编码',
    component: 'TaxBrowseComponent',
    dataKey: 'taxCode'
  },
  {
    id: 'tax-taxName',
    name: '税率-金税名称',
    component: 'TaxBrowseComponent',
    dataKey: 'taxName'
  },
];

@Injectable({ providedIn: 'root' })
export class BizSelectService {


  getBizObjectList() {
    return BIZ_OBJECT_CONFIG;
  }

  getBizObject(id: string) {
    for (let i = 0; i < BIZ_OBJECT_CONFIG.length; i++) {
      let item = BIZ_OBJECT_CONFIG[i];
      if (item.id == id) {
        return item;
      }
    }
    return null;
  }
}
